/**
 * Notice shown when source control has renamed/moved the requested repository, i.e. the
 * resolved full name differs (case-insensitively) from what was requested.
 * Returns null when they match.
 */
export function repositoryMovedNotice(
  requestedFullName: string,
  resolvedFullName: string,
): string | null {
  if (resolvedFullName.toLowerCase() === requestedFullName.toLowerCase()) return null;
  return `Source control moved ${requestedFullName} to ${resolvedFullName}. Crowdex will use the current repository address.`;
}
